/**
 * @interface
 */
export class ProbeEventStatus {
  /**
   * @type {Boolean}
   * @private
   */
  _critical;

  constructor(critical = false) {
    this._critical = critical;
  }

  get critical() {
    return this._critical;
  }

  getTranslateTextKey() {
    throw new Error('Method must be implemented by subclass');
  }

  getBackgroundColor() {
    throw new Error('Method must be implemented by subclass');
  }

  getTextColor() {
    throw new Error('Method must be implemented by subclass');
  }

  getOutlineColor() {
    throw new Error('Method must be implemented by subclass');
  }
}
